import React from "react";

const AboutMe = () => {
  return (
    <div className="flex flex-col md:flex-row">
      <div className="w-full text-zinc-400 px-6 border-r-zinc-800 flex items-center">
        <div className="py-6">
          <h2 className="font-semibold mb-1">
            Hello! I'm <span className="text-designColor">Zakawat Abbas</span>
          </h2>
          <p className="text-base leading-6">
            I am the Founder &amp; CEO of ZakCodeX , a UK-based software development and digital transformation company
            helping startups, SMEs, and enterprises turn ambitious ideas into
            secure, scalable products. With 4+ years of experience in full-stack
            development, cloud computing, machine learning, and artificial
            intelligence, I lead the delivery of custom software, web and mobile
            applications, AI-powered automation, ecommerce platforms, and cloud
            solutions for clients across the UK, USA, UAE, and beyond. My focus is
            on combining modern technology, strategic thinking, and user-centered
            design to create measurable business value.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
